/**
 * API de bonificaciones de cupo Email marketing (Panel → coofit_core.tenant_email_marketing_bonus).
 */

import { httpClient } from '../http/client/httpClient';

export interface EmailMarketingBonusDTO {
  id: number;
  tenantId: string;
  period: string;
  messages: number;
  reason: string;
  createdAt: string;
  createdByUserId: number | null;
  createdByName: string | null;
  revokedAt: string | null;
  revokedByUserId: number | null;
  revokedByName: string | null;
  revokeReason: string | null;
}

function apiErrorMessage(err: unknown, fallback: string): Error {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: { message?: string } } }).response?.data;
    if (data?.message) return new Error(data.message);
  }
  if (err instanceof Error) return err;
  return new Error(fallback);
}

export async function listEmailMarketingBonuses(
  tenantId: string,
  opts?: { period?: string; includeRevoked?: boolean }
): Promise<EmailMarketingBonusDTO[]> {
  const params = new URLSearchParams();
  if (opts?.period) params.set('period', opts.period);
  if (opts?.includeRevoked) params.set('includeRevoked', '1');
  const q = params.toString() ? `?${params.toString()}` : '';
  try {
    const response = await httpClient.get<EmailMarketingBonusDTO[]>(
      `/email-marketing-bonus/by-tenant/${tenantId}${q}`
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudieron cargar las bonificaciones');
  }
}

export async function createEmailMarketingBonus(
  tenantId: string,
  body: { messages: number; reason: string; period?: string }
): Promise<EmailMarketingBonusDTO> {
  try {
    const response = await httpClient.post<EmailMarketingBonusDTO>(
      `/email-marketing-bonus/by-tenant/${tenantId}`,
      body
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo registrar la bonificación');
  }
}

export async function revokeEmailMarketingBonus(
  id: number,
  body: { revokeReason: string }
): Promise<EmailMarketingBonusDTO> {
  try {
    const response = await httpClient.post<EmailMarketingBonusDTO>(
      `/email-marketing-bonus/${id}/revoke`,
      body
    );
    return response.data;
  } catch (err) {
    throw apiErrorMessage(err, 'No se pudo anular la bonificación');
  }
}
